/**
 * editNoticeModule 系统公告新建/编辑
 * Qian.qianchen
 * 2019-06-27
 */
'use strict';
angular.module('editNoticeModule', [])
    . controller('editNoticeCtrl', ['$scope', 'trsHttpService', '$q', '$state', '$compile', '$element', 'systemNoticeService', 'trsTransferService', 'trsspliceString', 'ueditorService', '$timeout', '$validation', 'modalDialog', function($scope, trsHttpService, $q, $state, $compile, $element, systemNoticeService, trsTransferService, trsspliceString, ueditorService, $timeout, $validation, modalDialog) {
        initStatus();
        initData();

        /**
     * [initStatus description] 状态初始化
     * @return {[type]} [description]
     */
        function initStatus() {
            $scope.status = {
                noticeId: $state.params.noticeid ? $state.params.noticeid : 0,
                support: {},
            };
            $scope.data = {
                noticeType: [],
                contribution: 0
            };
        }

        /**
     * [initData description] 数据初始化
     * @return {[type]} [description]
     */
        function initData() {
            getNoticeTypeList().then(() => $scope.status.noticeId == 0 ? initNewData() : initEditData()).then(() => {
                loadDirective();
            });
        }

        /**
     * [initNewData description] 新建
     * @return {[type]} [description]
     */
        function initNewData() {
            let defer = $q.defer();
            $scope.list = {
                typeid: $scope.data.noticeType.length > 0 ? $scope.data.noticeType[0].typeid : -1,
                title: '',
                titlecolor: '',
                CONTENT: '',
                HTMLCONTENT: '',
                appendixinfo: [],
                groupids: '',
                userids: '',
                tenantids: '',
                alluser: false,
                tenantuser: true
            };
            $scope.data.selectedOrg = [];
            defer.resolve();
            return defer.promise;
        }

        /**
     * [initEditData description] 获取公告信息
     * @return {[type]} [description]
     */
        function initEditData() {
            let defer = $q.defer();
            let params = {
                serviceid: 'notice',
                method: 'noticeDetial',
                noticeid: $scope.status.noticeId
            };
            trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'GET').then((data) => {
                $scope.list = {
                    typeid: -1,
                    title: data.data.title,
                    titlecolor: data.data.titlecolor,
                    CONTENT: data.data.content,
                    HTMLCONTENT: data.data.content,
                    appendixinfo: data.data.appendixs.map((_item) => ({
                        FileSize: _item.filesize,
                        FileDesc: _item.filedesc,
                        FileName: _item.filename,
                    })),
                    tenantids: data.data.tenantuser ? '' : data.data.tenantids,
                    alluser: data.data.alluser,
                    tenantuser: data.data.tenantuser
                };
                typeFormat(data.data.typeid);
                $scope.data.contribution = data.data.tenantuser ? 0 : 1;
                $scope.data.selectedOrg = data.data.tenantuser ? [] : data.data.tenants.map((_item) => ({ TENANTNAME: _item.TENANTNAME, TENANTID: _item.ID }));
                $scope.data.selectedOrgName = data.data.tenantuser ? [] : trsspliceString.spliceString(data.data.tenants, 'TENANTNAME', '、');
                defer.resolve();
            });
            return defer.promise;
        }

        /**
     * [getNoticeTypeList description] 获取公告类型
     * @return {[type]} [description]
     */
        function getNoticeTypeList() {
            let defer = $q.defer();
            let params = {
                serviceid: 'noticetype',
                method: 'noticetypeForDetail'
            };
            trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'GET').then((data) => {
                if (data.issuccess == 'false') {
                    modalDialog.alertType('', data.msg, 'error', false);
                    defer.reject();
                } else {
                    $scope.data.noticeType = [].concat(data.data);
                    defer.resolve();
                }
            });
            return defer.promise;
        }

        /**
     * [typeFormat description] 公告类型处理（如果选中的公告类型被停用，清空选中的公告类型）
     * @param  {[type]} typeId [description] 原来选中的公告类型ID
     * @return {[type]}        [description]
     */
        function typeFormat(typeId) {
            for (let i = 0; i < $scope.data.noticeType.length; i++) {
                if ($scope.data.noticeType[i].typeid == typeId) {
                    $scope.list.typeid = typeId;
                    return;
                }
            }
        }

        /**
     * [loadDirective description] 动态加载编辑器指令
     * @return {[type]} [description]
     */
        function loadDirective() {
            var defer = $q.defer();
            LazyLoad.js(['./lib/ueditor2/ueditor.config.js?v=11.5', './lib/ueditor2/ueditor.all.js?v=11.7'], function() {

                var ueditor = '<ueditor-for-notice has-content="status.hasContent" versionid = "data.lastVersionid" list="list" infullscreen="status.infullscreen" speed="' + $scope.data.speed + '"></ueditor-for-manuscript>';
                // $scope.button = { title: "政治常识校对", name: "polComSense" };
                // var ueditor = '<ueditor custom-button-fn="politicalCommonSense()" custom-button="button" form="manuscriptForm" versionid = "data.lastVersionid" list="list"></ueditor>';
                ueditor = $compile(ueditor)($scope);
                $element.find('ueditorLocation').append(ueditor);
                $scope.status.support.content = $scope.list.CONTENT;
                var ue = UE.getEditor('ueditor');
                ue.ready(function() {
                    ue.addListener('keydown', function(type, event) {
                        if (event.keyCode === 13) {
                        // 获取纯文本
                            $scope.status.support.content = ue.getContentTxt();
                        }
                    });
                    defer.resolve();
                });
            });
            return defer.promise;
        }

        /**
     * [save description] 保存
     * @return {[type]} [description]
     */
        function save() {
            let defer = $q.defer();
            ueditorService.saveContent($scope.list);
            if ($scope.list.typeid == -1) {
                modalDialog.alertType('', '请选择启用的通知类型', 'error', false);
                defer.reject();
                return;
            }
            if ($scope.list.CONTENT.length > 1000) {
                modalDialog.alertType('', '纯文本内容不得超过1000字', 'error', false);
                defer.reject();
                return;
            }
            $timeout(function() {
                $scope.noticeForm.$pending = {};
                $validation.validate($scope.noticeForm)
                    .success(function() {
                        let params = {
                            typeid: $scope.list.typeid,
                            title: $scope.list.title,
                            titlecolor: $scope.list.titlecolor,
                            content: $scope.list.HTMLCONTENT,
                            appendixinfo: JSON.stringify($scope.list.appendixinfo),
                            alluser: false,
                            tenantuser: $scope.data.contribution == 0,
                            serviceid: 'notice',
                            method: $scope.status.noticeId == 0 ? 'saveNotice' : 'updateNotice'
                        };
                        if ($scope.status.noticeId != 0) {
                            params.noticeid = $scope.status.noticeId;
                        }
                        if ($scope.data.contribution == 1) {
                            params.tenantids = trsspliceString.spliceString($scope.data.selectedOrg, 'TENANTID', ',');
                        }
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'POST').then(function(data) {
                            if (data.issuccess == 'true') {
                                $state.params.noticeid = data.data.noticeid;
                                $state.transitionTo($state.current, $state.params, {
                                    reload: false
                                });
                                defer.resolve(data.data.noticeid);
                            } else {
                                modalDialog.alertType('', data.msg, 'error', false);
                                defer.reject();
                            }
                        });
                    }).error(function(msg) {
                        angular.invalidPosition($scope.noticeForm, $element);
                        defer.reject();
                    });
            });
            return defer.promise;
        }

        /**
     * [publish description]发布
     * @param  {[type]} noticeId [description] 公告ID
     * @return {[type]}          [description]
     */
        function publish(noticeId) {
            let defer = $q.defer();
            let params = {
                serviceid: 'notice',
                method: 'publishNotice',
                noticeids: noticeId
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'POST').then(function(data) {
                if (data.issuccess == 'true') {
                    defer.resolve();
                } else if (data.msg == null) {
                    modalDialog.alertType('', data.data[0].msg, 'error', false);
                } else {
                    modalDialog.alertType('', data.msg, 'error', false);
                    defer.reject();
                }
            });
            return defer.promise;
        }

        /**
     * [theFormError description] 获取表单变化
     * @return {[type]} [description]
     */
        $scope.theFormError = function() { // 当表单发生变化时会进入方法
            var errorArray = [];
            for (var error in $scope.noticeForm.$error) {
                errorArray.push(error);
            }
            $scope.status.noticeForm = $scope.status.noticeFormError == undefined ? [] : $scope.status.noticeFormError;
            if ($scope.status.noticeFormError.length != errorArray.length) { // 长度不相等说明表单errorname发生变化
                $scope.status.noticeFormError = errorArray;
            }
            return $scope.status.noticeFormError; // 返回
        };

        /**
     * [uploadFile description] 文件上传
     * @return {[type]} [description]
     */
        $scope.uploadFile = function() {
            systemNoticeService.uploadFiles().then((data) => {
                $scope.list.appendixinfo = $scope.list.appendixinfo.concat(data);
            });
        };

        /**
     * [deleteFile description] 删除文件
     * @param  {[type]} file [description]
     * @return {[type]}      [description]
     */
        $scope.deleteFile = function(file) {
            $scope.list.appendixinfo.splice($scope.list.appendixinfo.indexOf(file), 1);
        };

        /**
     * [selectDistribution description] 选择发布范围
     * @return {[type]} [description]
     */
        $scope.selectDistribution = function() {
            systemNoticeService.tenantTransfer(function(result) {
                console.log(result);
                $scope.data.selectedOrg = result;
                $scope.data.selectedOrgName = trsspliceString.spliceString($scope.data.selectedOrg, 'TENANTNAME', '、');
            }, $scope.data.selectedOrg);
        };

        /**
     * [goBack description] 返回
     * @return {[type]} [description]
     */
        $scope.cancel = function() {
            $state.go('manageconfig.sysmanage.systemnotice', {}, { reload: false });
        };

        /**
     * [save description] 保存
     * @return {[type]} [description]
     */
        $scope.save = function() {
            save().then((data) => {
                modalDialog.alertType('', '新建公告成功！', 'success', false, function() {
                    $state.go('manageconfig.sysmanage.systemnotice');
                });
            });
        };

        /**
     * [saveAndPublish description] 保存并发布
     * @return {[type]} [description]
     */
        $scope.saveAndPublish = function() {
            save().then((noticeId) => {
                publish(noticeId).then(() => {
                    modalDialog.alertType('', '发布公告成功！', 'success', false, function() {
                        $state.go('manageconfig.sysmanage.systemnotice');
                    });
                });
            });
        };

        /**
     * [selectedNoticeType description] 选择公告类型
     * @param  {[type]} type [description] 公告
     * @return {[type]}      [description]
     */
        $scope.selectedNoticeType = function(type) {
            $scope.list.typeid = type.typeid;
        };
    }]);
